import { Component, AfterViewInit, OnDestroy, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererParams } from 'ag-grid-community';
import Tooltip from 'bootstrap/js/dist/tooltip';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-action-maintenance',
    templateUrl: './action-maintenance.component.html',
    styleUrls: ['./action-maintenance.component.css']
})
export class ActionMaintenanceComponent implements AfterViewInit, OnDestroy {
    private tooltips: any[] = [];
    role:string = '';

    constructor(private router: Router, private el: ElementRef<HTMLElement>, private permissionService: PermissionService) { }
    ngOnInit(): void {
    }

    public cellValue!: any;

    // gets called once before the renderer is used
    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
        this.role = this.cellValue?.role;
    }

    getAddSupplier() {
        if (this.cellValue?.data?.maintenance_type.name.toLowerCase() == 'interno') {
            return this.router.navigateByUrl('/maintenance/repair/add', { state: { data: { maintenance_id: this.cellValue?.data?.id, isExternal: false } } })
        }
        else {
            return this.router.navigateByUrl('/maintenance/supplier/add', { state: { data: { maintenance_id: this.cellValue?.data?.id, isExternal: true } } })
        }
    }
    getSupplierComparison() {
        return this.router.navigateByUrl('/maintenance/supplier/comparison', { state: { data: { maintenance_id: this.cellValue?.data?.id } } })
    }
    getAuthorization() {
        return this.router.navigateByUrl('/maintenance/authorization', { state: { data: { maintenance_id: this.cellValue?.data?.id } } })
    }
    getPayment(type: number) {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.openModalPayment(this.cellValue.data, type)
    }
    getTracking() {
        return this.router.navigateByUrl('/maintenance/tracking', { state: { data: { maintenance_id: this.cellValue?.data?.id } } })
    }
    getAttachment() {
        return this.router.navigateByUrl('/maintenance/attachment', { state: { data: { maintenance_id: this.cellValue?.data?.id } } })
    }
    getChangeStatus(type:number) {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.openModalChangedStatus(this.cellValue.data, type)
    }
    getCancel() {
        return this.router.navigateByUrl('/maintenance/cancel', { state: { data: { maintenance_id: this.cellValue?.data?.id } } })
    }

    ngAfterViewInit(): void {
        // Initialize Bootstrap 5 tooltips for elements within this component
        const tooltipTriggerList = Array.from(
            this.el.nativeElement.querySelectorAll('[data-bs-toggle="tooltip"]')
        ) as HTMLElement[];
        this.tooltips = tooltipTriggerList.map(el => new Tooltip(el));
    }

    ngOnDestroy(): void {
        // Dispose tooltips to avoid memory leaks when AG Grid destroys the renderer
        this.tooltips.forEach(t => t.dispose());
        this.tooltips = [];
    }
    cancelStatus() {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.openModalCancel(this.cellValue.data)
    }
    downloadInvoice() {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.downloadInvoice(this.cellValue.data)
    }
    modifyMaintenance() {
        return this.router.navigateByUrl('/maintenance/update', { state: { data: this.cellValue?.data } })
    }
    detailSolicitud() {
        return this.router.navigateByUrl('/maintenance/view/' + this.cellValue?.data?.id)
    }

    canDo(moduleKey: string, actionName: string): boolean {
        return this.permissionService.canDo(moduleKey, actionName);
    }
    openModalPaymentMade() {
        if (!this.cellValue?.parent) { return; }
        this.cellValue.parent.openModalPaymentMade(this.cellValue.data)
    }
}
